<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-between">
    <div>
      <Nav />

      <div class="max-w-xl mx-auto my-10 px-4">
        <div class="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200 p-6 md:p-8">
          <img src="/amazon-items-image.webp" alt="Amazon Items" class="w-full object-cover max-h-48 rounded-md shadow-sm mb-6" />

          <h1 class="text-center text-xl font-bold text-gray-800 mb-6 font-serif">
            Add Detail Information about your Products
          </h1>

          <div class="space-y-6">
            <div>
              <label class="block text-lg font-serif text-gray-700 mb-2">Attributes:</label>
              <select
                v-model="model.quantities.attribute_id"
                class="w-full h-12 px-3 font-serif text-lg focus:outline-none focus:ring-2 focus:ring-green-400 rounded-md border border-gray-300 bg-green-50 focus:bg-white transition"
              >
                <option v-for="attribute in attributes" :key="attribute.id" :value="attribute.id">
                  {{ attribute.name }}
                </option>
              </select>
            </div>

            <div v-if="model.quantities.attribute_id !== null">
              <div v-if="model.quantities.attribute_id !== 15 && model.quantities.attribute_id !== 5">
                <label class="block text-lg font-serif text-gray-700 mb-2">Values:</label>
                <input
                  type="text"
                  class="w-full h-12 px-3 font-serif text-lg focus:outline-none focus:ring-2 focus:ring-green-400 rounded-md border border-gray-300 bg-green-50 focus:bg-white transition"
                  v-model="model.quantities.value"
                />
              </div>

              <div v-if="model.quantities.attribute_id === 15">
                <label class="block text-lg font-serif text-gray-700 text-center mb-2">Drop The Images Of Your Product Here</label>
                <input
                  type="file"
                  @change="handlephoto"
                  class="w-full h-12 py-2 px-3 font-serif text-lg focus:outline-none rounded-md border border-gray-300 bg-green-50 focus:bg-white file:mr-4 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-gray-200 file:text-gray-700 hover:file:bg-gray-300 cursor-pointer"
                />
              </div>

              <div v-if="model.quantities.attribute_id === 5">
                <label class="block text-lg font-serif text-gray-700 text-center mb-2">Put Some descriptions about your product here</label>
                <textarea
                  rows="4"
                  class="w-full p-3 bg-green-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-green-400 rounded-md border border-gray-300 transition"
                  v-model="model.quantities.value"
                ></textarea>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row gap-4 justify-center pt-4">
              <button
                :disabled="isLoading"
                @click="postValues"
                class="bg-yellow-400 hover:bg-yellow-500 disabled:opacity-50 text-gray-900 font-bold px-8 py-3 rounded-full shadow-sm text-base font-serif transition-all duration-150 flex items-center justify-center gap-2"
              >
                <span v-if="isLoading" class="animate-spin inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full"></span>
                <span>{{ isLoading ? 'Adding...' : 'Add Detail' }}</span>
              </button>
              <button
                class="border border-gray-300 hover:bg-gray-100 bg-white text-gray-800 font-bold px-8 py-3 rounded-full text-base font-serif transition-colors duration-150"
                @click="addProduct"
              >
                Add Another Product
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useEcommerceStore } from '@/stores/Ecommerce';
import axios from 'axios';
import { useRouter } from 'vue-router';
import Nav from "@/components/Nav.vue";

export default {
  components: {
    Nav,
  },
  data(){
    return{
      attributes:[],
      isLoading: false,
      model:{
        quantities:{
          user_id:null,
          item_id:null,
          attribute_id:null,
          value:''
        }
      }
    }
  },
  mounted(){
    this.fetchAttribute();
    this.model.quantities.user_id = localStorage.getItem("userID");
    const EcommerceStore = useEcommerceStore();
    const router = useRouter();
    EcommerceStore.verifyLogin(router);
    this.model.quantities.item_id = localStorage.getItem('item_id')
  },
  methods:{
    async fetchAttribute(){
      const response = await axios.get('https://ecommerce-api.kalkidan.net/api/attribute')
      this.attributes = response.data.attribute
    },
    async postValues(){
      if (this.isLoading) return;
      this.isLoading = true;
      const formData = new FormData()
      formData.append('user_id',this.model.quantities.user_id)
      formData.append('item_id',this.model.quantities.item_id )
      formData.append('attribute_id',this.model.quantities.attribute_id)
      formData.append('value',this.model.quantities.value)
      try{
        const res = await axios.post('https://ecommerce-api.kalkidan.net/api/value',formData,{
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        alert(`Your Response Submitted. Add Another Attribute.`)
        console.log(res.data)
        this.model.quantities.value = ''
        this.model.quantities.attribute_id = null
      }catch(error){
        console.log('error',error)
        alert('Failed to add attribute details. Please try again.')
      } finally {
        this.isLoading = false;
      }
    },
    handlephoto(event) {
      const file = event.target.files[0]
      if (file) {
        this.model.quantities.value = event.target.files[0]
      }
    },
    addProduct(){
      this.$router.push('/PostProduct')
    }
  }
}
</script>

<style scoped>
</style>
